
<template >
  <div class="products-grid ma-4">
    <v-row no-gutters >
      <v-col cols="8" class="text-">
        <span class="text-left pr-4" style="font-size:20px;" >
          <strong>Yhteensä {{getTotal}} € (alv 0%)</strong>
        </span>
        
        <span class="pl-6">
          Toimituskulut:
          <v-text-field
            class="maxw-100"
            style="padding-left:5px; display:inline-block; font-size:18px !important;"
            v-model="deliveryCharges"
            suffix="€"
          ></v-text-field>
        </span>
        <span class="pl-6">
          <div style="border:1px dashed #ccc;font-size:10px;color:#666;padding:5px;display:inline-block;" class="ml-5 px-2 py-1">
            <div><b>Toimituksen lisätiedot</b></div>
            <div>
              <input style="height:10px;width:10px;vertical-align: middle;" type="checkbox" v-model="deliveryBySalesperson" /> 
              <span style="vertical-align: middle;padding-left:5px;">Myyjä toimittaa</span>
            </div>
            <div>
              <input style="height:10px;width:10px;vertical-align: middle;" type="checkbox" v-model="isAmendmentOrder" /> 
              <span style="vertical-align: middle;padding-left:5px;">Lisätilaus</span>
            </div>
          </div>
        </span>
      </v-col>
      
      <v-spacer></v-spacer>
      <v-btn color="#000000" dark class="add-button avecor-button-global"  @click="addRow">Lisää tuote</v-btn>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="6" class="pa-4 mb-5" v-for="(product, index) in newOrderProducts"  style="background:#eee; border:1px dotted #ccc; position:relative" :key="'new-prodcut-'+index">
        <div>Tuote {{index+1}}
          <v-checkbox 
            label="Onko tämä mallitilaus?"
            v-model="product.sample" 
            class="avecor-table-checkbox ma-0 pa-0"
            style="display:inline-block;">
          </v-checkbox>
          <span v-if="productVariations[product.productVariationId] !== undefined && productVariations[product.productVariationId].warehoused" style="padding-left:20px; font-weight:bold; font-size:12px; color:#F36638">Varastotuote |</span>
          <span v-if="products[product.productId] !== undefined && products[product.productId].listed" style="padding-left:2px; font-weight:bold; font-size:12px; color:#F36638">Hinnastotuote </span>
          <span v-if="products[product.productId] !== undefined && products[product.productId].listed &&  products[product.productId].isMarginCalculationActivated" style="padding-left:2px; font-weight:bold; font-size:12px; color:green">| Automatisoitu katelaskenta </span>
        </div>
        <div style="position:absolute; top:10px; right:10px;">
          <v-icon style=""
            small
            @click="deleteItem(index)"
          >
            far fa-trash-alt
          </v-icon>
        </div>
        <v-row no-gutters>
          <v-col cols="12" md="3" class="pr-3">
            <v-autocomplete
              v-model="product.productVariationId"
              :items="getCatalogProductsAndVariations"
              label="Etsi tuotteita"
              autocomplete="off"
              item-text="text"
              item-value="value"
              class="red-caret" 
              @change="productFieldChanged(index)"
              :error-messages="productsErrors[index].productName"
              chips
            >
              <template v-slot:selection="data">
                <v-chip
                  :input-value="data.selected"
                  close
                  small
                  class="chip--select-multi"
                  @click:close="removeProductSelection(index)"
                >
                  {{ data.item.text.substr(0,20) }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3" class="pr-3">
            <v-text-field
              v-model="product.productName"
              label="Tuotenimi*"
              
              @blur="fieldUpdated('productName', index)"
              @keyup="fieldUpdated('productName', index)"
              :disabled="true"
              />
              <!-- :error-messages="productsErrors[index].productName" -->
          </v-col>
          <!-- :disabled="product.productVariationId !== ''" -->
          <v-col cols="3" md="2" class="pr-3">
            <v-text-field
              v-model="product.avecorSku"
              label="Tuotekoodi*"
              :error-messages="productsErrors[index].avecorSku"
              @blur="fieldUpdated('sku', index)"
              @keyup="fieldUpdated('sku', index)"
              :disabled="true"
              />
          </v-col>
          <v-col cols="3" md="1" class="pr-3">
            <v-text-field
              v-model="product.color"
              label="Väri"
              :error-messages="productsErrors[index].color"
              @blur="fieldUpdated('color', index)"
              @keyup="fieldUpdated('color', index)"
              :disabled="true"
              />
          </v-col>
          <v-col cols="3" md="1" class="pr-3">
            <v-text-field
              v-model="product.size"
              label="Koko"
              @blur="fieldUpdated('size', index)"
              @keyup="fieldUpdated('size', index)"
              :disabled="true"
              />
          </v-col>
          <v-col cols="3" md="2" class="pr-3" v-if="!isSamplesOrder">
            <v-autocomplete
              v-model="product.packageType"
              label="Pakkaustyyppi*"
              :items="getPackageTypes"
              :error-messages="productsErrors[index].packageType"
              @blur="fieldUpdated('packageType', index)"
              @keyup="fieldUpdated('packageType', index)"
              item-text="fi"
              item-value="id"
              :disabled="true"
              />
          </v-col>
          <!-- <v-col cols="3" md="2" class="pr-3" v-if="isSamplesOrder">
            <v-select
              label="Mallikappaleiden määrä"
              autocomplete="off"
              :items="samplesArray"
              v-model="product.numberOfSamples"
            />
          </v-col> -->
        </v-row> 
        <v-row no-gutters v-if="!isSamplesOrder">
          <v-col cols="12" md="3" class="pr-3">
            <v-textarea
              label="Asiakkaalle näkyvä tuotenimi (valinnainen)"
              autocomplete="off"
              :auto-grow="true"
              v-model="product.customerProductName"
              :error-messages="productsErrors[index].customerProductName"
              @blur="fieldUpdated('customerProductName', index)"
              @keyup="fieldUpdated('customerProductName', index)"
              rows=1
              />
          </v-col>
          <v-col cols="3" md="2" class="pr-3">
            <v-text-field
              label="Määrä*"
              type="number"
              autocomplete="off"
              v-model="product.quantity"
              :error-messages="productsErrors[index].quantity"
              @blur="fieldUpdated('quantity', index)"
              @keyup="fieldUpdated('quantity', index)"
              />
          </v-col>
          <v-col cols="3" md="2" class="pr-3">
            <v-text-field
              label="á hinta*"
              autocomplete="off"
              v-model="product.unitPrice"
              :error-messages="productsErrors[index].unitPrice"
              @blur="fieldUpdated('unitPrice', index)"
              @keyup="fieldUpdated('unitPrice', index)"
              />
          </v-col>
          <v-col cols="3" md="1" class="pr-3">
            <v-select
              label="Mallikappaleiden määrä"
              :items="samplesArray"
              v-model="product.numberOfSamples"
              />
          </v-col>
          <v-col cols="3" md="2" class="pr-3">
            <v-menu
              :nudge-right="40"
              transition="fade-transition"
              offset-y
              min-width="30px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  label="Viimeistään asiakkaalla"
                  v-model="product.latestToCustomer"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="product.latestToCustomer"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3" md="2" class="pr-3">
            <v-menu
              :nudge-right="40"
              transition="fade-transition"
              offset-y
              min-width="30px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  label="Toivottu laskutuspäivä"
                  v-model="product.whenToInvoice"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="product.whenToInvoice"></v-date-picker>
            </v-menu>
          </v-col>

          
        </v-row>
        <v-row no-gutters v-if="!isSamplesOrder" class="pb-0">
          <v-col cols="12" md="3" class="text-left">
            <div class="pt-4">
              <input style="height:14px;width:14px;vertical-align: middle;" type="checkbox" v-model="product.print" /> 
              <span style="vertical-align: middle;padding-left:5px;font-size:12px;">Tuleeko merkkausta?</span>
            </div>
            <!-- <v-checkbox 
              label="Tuleeko merkkausta?"
              v-model="product.print" 
              @change="toggledProductPrint"
              class="avecor-table-checkbox">
            </v-checkbox> -->
          </v-col>
          <v-col cols="6" md="2" class="pr-3">
            <v-text-field
              v-if="product.print"
              label="Merkkausten määrä"
              type="number"
              v-model="product.printQuantity"
              @keyup="fieldUpdated('printQuantity', index)"
              :error-messages="productsErrors[index].printQuantity"
            ></v-text-field>  
          </v-col>
          <v-col cols="6" md="2" class="pr-3">
            <v-text-field
            v-if="product.print"  
            label="Merkkausten á hinta"
              v-model="product.unitPrintPrice"
              @keyup="fieldUpdated('unitPrintPrice', index)"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="2" class="pr-3">
            <v-text-field
              v-if="product.print"  
              label="Asemoinnin määrä"
              v-model="product.numberOfPositionings"
              :error-messages="productsErrors[index].numberOfPositionings"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="2" class="pr-3">
            <v-text-field
              v-if="product.print"  
              :rules="[settings.noCommas]"
              label="Asemoinnin á hinta"
              v-model="product.pricePerPositioning"
              @keyup="fieldUpdated('pricePerPositioning', index)"
              :error-messages="productsErrors[index].pricePerPositioning"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- FIRST PRINT -->
        <v-row no-gutters v-if="!isSamplesOrder && product.print">
          <v-col cols="12" md="12" v-if="products[product.productId] && products[product.productId].listed && products[product.productId].isMarginCalculationActivated">
            <v-row no-gutters>
              <v-col cols="12" md="12" class="pr-3">
                <v-autocomplete
                  label="Merkkaustapa*"
                  v-model="product.printOptions"
                  :items="printFormatsFromPricingForProduct(product.productId,true)"
                  @change="e => productsErrors[index].printOptions = ''"
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  multiple
                  small-chips
                  :error-messages="productsErrors[index].printOptions"
                  content-class="custom-print-format-autocomplete"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      small
                    >
                      <span>{{ data.item.text }} </span>
                      <span v-if="product.printOptionsSettings[data.item.id] && product.printOptionsSettings[data.item.id].renewal">
                        <span class="pl-1"> | Uusinta-aloitus</span>
                        <i v-if="product.printOptionsSettings[data.item.id] && product.printOptionsSettings[data.item.id].renewal" :style="'color:#555;font-size:12px;cursor:pointer;'" class="far fa-check-square pl-1 pr-2"></i>
                        <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" class="far fa-square pl-1 pr-2"></i>
                      </span>
                      <span v-if="product.printOptionsSettings[data.item.id] && product.printOptionsSettings[data.item.id].colors" class="pl-1"> | Värien määrä {{product.printOptionsSettings[data.item.id].colors }}</span>
                      
                    </v-chip>
                  </template>
                  <template v-slot:item="{active, item, attrs, on }" >
                    <v-list-item v-on="on" v-bind="attrs" #default="{ active }" style="min-width:350px;color:#000;" class="custom-print-format-list-item px-0" dense>
                      <v-list-item-content @click.stop="()=>{}"> 
                        <v-list-item-title @click.stop="()=>{}">
                          <v-row no-gutters align="center" style="color:#000 !important;" @click.stop="()=>{}" class="px-4">
                            <span @click.stop="()=>{}">
                              <i v-if="active" :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption(index,'remove',item.id);productsErrors[index].printOptions = ''" class="far fa-check-square pl-1 pr-2"></i>
                              <i v-else :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption(index,'add',item.id);productsErrors[index].printOptions = ''" class="far fa-square pl-1 pr-2"></i>
                              <span>{{item.text}}</span>
                            </span>
                            <v-spacer></v-spacer>
                            <div v-if="product.printOptionsSettings[item.id] && ((item.extraCosts && item.extraCosts.length > 0) || item.renewAvailable || (item.pfId !== 'laser' && item.pfId !== 'digital_print' && item.pfId !== 'uv_laser'))" style="background:#eee;padding:4px;border:1px dotted #ccc;display:inline-block;width:405px;">
                              <div v-if="item.renewAvailable">
                                <i v-if="product.printOptionsSettings[item.id] && product.printOptionsSettings[item.id].renewal" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'renewal', index, item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'renewal', index, item.id, true)" class="far fa-square pl-1 pr-2"></i>
                                <div style="display:inline-block;width:100px;" class="pr-2">Uusinta-aloitus</div>
                              </div>
                              <div class="pt-0" v-if="item.pfId !== 'laser' && item.pfId !== 'digital_print' && item.pfId !== 'uv_laser'" >
                                <!-- <input :value="product.printOptionsSettings[item.id] && product.printOptionsSettings[item.id].colors !== undefined ? product.printOptionsSettings[item.id].colors : '' " style="border:1px solid #ccc;color:#000;width:20px;padding-left:2px;" class="ml-1 "> -->
                                <i v-if="product.printOptionsSettings[item.id] && product.printOptionsSettings[item.id].colors && product.printOptionsSettings[item.id].colors > 1" class="fas fa-minus-circle ml-1" @click="printOptionSettingUpdate(1,'colors', index, item.id, 'subtract')" ></i>
                                <i v-else class="fas fa-minus-circle ml-1" style="color:#ccc" ></i>
                                <span class="px-1 mx-1" style="border:1px solid #ccc;background:#FFF;">{{product.printOptionsSettings[item.id].colors ? product.printOptionsSettings[item.id].colors : '-'}}</span>
                                <i class="fas fa-plus-circle" @click="printOptionSettingUpdate(1,'colors', index, item.id, 'add');productsErrors[index].printOptions = ''" ></i>
                                <div style="display:inline-block;width:100px;" class="pr-2">Värien määrä</div>
                              </div>
                              <div v-if="item.extraCosts && item.extraCosts.length > 0" class="pt-2">
                                <div v-for="(ec, i) in item.extraCosts" :key="ec.id+'_ec_'+i">
                                  <i v-if="product.printOptionsSettings[item.id] && product.printOptionsSettings[item.id]['ec_'+ec.id]" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'ec_'+ec.id, index, item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                  <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'ec_'+ec.id, index, item.id, true)" class="far fa-square pl-1 pr-2"></i>
                                  <div style="display:inline-block;" class="pr-2">{{ec.name + ' ('+ec.price+'€)'}}</div>
                                </div>
                              </div>
                            </div>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-else cols="12" md="12" class="pr-3">
            <v-row no-gutters>
              <v-col cols="6" md="6" class="pr-3" v-if="products[product.productId] && products[product.productId].printFormats && Array.isArray(products[product.productId].printFormats) &&  products[product.productId].printFormats.length > 0">
                <v-autocomplete
                  label="Merkkaustapa*"
                  v-model="product.printFormats"
                  :items="printFormatsForProduct(product)"
                  @change="e => productsErrors[index].printFormats = ''"
                  persistent-hint
                  item-text="fi"
                  item-value="id"
                  multiple
                  :error-messages="productsErrors[index].printFormats"
                />
              </v-col>
              <v-col cols="6" md="6" class="pr-3" v-else>
                <v-text-field
                  label="Merkkaustapa"
                  @blur="fieldUpdated('printFormatsText', index)"
                  @keyup="fieldUpdated('printFormatsText', index)"
                  v-model="product.printFormatsText"
                  v-if="product.print"
                  :error-messages="productsErrors[index].printFormatsText"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6" class="pr-3" v-if="product.print">
                <!-- laser digital_print uv_laser -->
                <v-autocomplete
                  :disabled="product.printFormats.includes('laser') || product.printFormats.includes('digital_print') || product.printFormats.includes('uv_laser')"
                  :label="product.printFormats.includes('laser') || product.printFormats.includes('digital_print') || product.printFormats.includes('uv_laser') ? '-' : 'Värien määrä*'"
                  v-model="product.numberOfPrintColors"
                  :items="settings.numberOfPrintColors"
                  @change="e => productsErrors[index].numberOfPrintColors = ''"
                  persistent-hint
                  :error-messages="productsErrors[index].numberOfPrintColors"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6" md="3" class="pr-3">
            <v-text-field
              label="Merkkausväri"
              v-model="product.printColor"
              v-if="product.print"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3" class="pr-3">
            <v-text-field
              label="Merkkauskohta"
              v-model="product.printLocation"
              v-if="product.print"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3" class="pr-3">
            <v-textarea
              label="Mitä merkataan?"
              :auto-grow="true"
              v-model="product.printContent"
              rows=1
              v-if="product.print"
              hint="Tuleeko lisäksi liitetietoja painettavaan tuotteeseen, esim. puh., www-osoite, tuotetietoja? Mitä?"
              persistent-hint
              class="small-hint"
              />
          </v-col>
          <v-col cols="12" md="3" class="pr-3">
            <v-textarea
              label="Merkkauksen lisätiedot"
              :auto-grow="true"
              v-model="product.printComments"
              rows=1
              v-if="product.print"
              />
          </v-col>
        </v-row>
        <v-row v-if="!isSamplesOrder && product.print">
          <v-col cols="12" class="px-3 text-left">
            <div>
              <input style="height:14px;width:14px;vertical-align: middle;" type="checkbox" v-model="product.secondPrint" /> 
              <span style="vertical-align: middle;padding-left:5px;font-size:12px;">Tuleeko toinen merkkaus?</span>
            </div>
          </v-col>
        </v-row>

        <!-- SECOND PRINT -->
        <v-row no-gutters v-if="!isSamplesOrder && product.print && product.secondPrint" class="pt-5">
          <v-col cols="12" md="12" v-if="products[product.productId] && products[product.productId].listed && products[product.productId].isMarginCalculationActivated">
            <v-row no-gutters>
              <v-col cols="12" md="12" class="pr-3">
                <v-autocomplete
                  label="Merkkaustapa*"
                  v-model="product.printOptions2"
                  :items="printFormatsFromPricingForProduct(product.productId,true)"
                  @change="e => productsErrors[index].printOptions2 = ''"
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  multiple
                  small-chips
                  :error-messages="productsErrors[index].printOptions2"
                  content-class="custom-print-format-autocomplete"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      small
                    >
                      <span>{{ data.item.text }} </span>
                      <span v-if="product.printOptionsSettings2[data.item.id] && product.printOptionsSettings2[data.item.id].renewal">
                        <span class="pl-1"> | Uusinta-aloitus</span>
                        <i v-if="product.printOptionsSettings2[data.item.id] && product.printOptionsSettings2[data.item.id].renewal" :style="'color:#555;font-size:12px;cursor:pointer;'" class="far fa-check-square pl-1 pr-2"></i>
                        <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" class="far fa-square pl-1 pr-2"></i>
                      </span>
                      <span v-if="product.printOptionsSettings2[data.item.id] && product.printOptionsSettings2[data.item.id].colors" class="pl-1"> | Värien määrä {{product.printOptionsSettings2[data.item.id].colors }}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{active, item, attrs, on }" >
                    <v-list-item v-on="on" v-bind="attrs" #default="{ active }" style="min-width:350px;color:#000;" class="custom-print-format-list-item px-0" dense>
                      <v-list-item-content @click.stop="()=>{}"> 
                        <v-list-item-title @click.stop="()=>{}">
                          <v-row no-gutters align="center" style="color:#000 !important;" @click.stop="()=>{}" class="px-4">
                            <span @click.stop="()=>{}">
                              <i v-if="active" :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption2(index,'remove',item.id);productsErrors[index].printOptions2 = ''" class="far fa-check-square pl-1 pr-2"></i>
                              <i v-else :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption2(index,'add',item.id);productsErrors[index].printOptions2 = ''" class="far fa-square pl-1 pr-2"></i>
                              <span>{{item.text}}</span>
                            </span>
                            <v-spacer></v-spacer>
                            <div v-if="product.printOptionsSettings2[item.id] && ((item.extraCosts && item.extraCosts.length > 0) || item.renewAvailable || (item.pfId !== 'laser' && item.pfId !== 'digital_print' && item.pfId !== 'uv_laser'))" style="background:#eee;padding:4px;border:1px dotted #ccc;display:inline-block;width:405px;">
                              <div v-if="item.renewAvailable">
                                <i v-if="product.printOptionsSettings2[item.id] && product.printOptionsSettings2[item.id].renewal" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'renewal', index, item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'renewal', index, item.id, true)" class="far fa-square pl-1 pr-2"></i>
                                <div style="display:inline-block;width:100px;" class="pr-2">Uusinta-aloitus</div>
                              </div>
                              <div class="pt-0" v-if="item.pfId !== 'laser' && item.pfId !== 'digital_print' && item.pfId !== 'uv_laser'" >
                                <i v-if="product.printOptionsSettings2[item.id] && product.printOptionsSettings2[item.id].colors && product.printOptionsSettings2[item.id].colors > 1" class="fas fa-minus-circle ml-1" @click="printOptionSettingUpdate(2,'colors', index, item.id, 'subtract')" ></i>
                                <i v-else class="fas fa-minus-circle ml-1" style="color:#ccc" ></i>
                                <span class="px-1 mx-1" style="border:1px solid #ccc;background:#FFF;">{{product.printOptionsSettings2[item.id].colors ? product.printOptionsSettings2[item.id].colors : '-'}}</span>
                                <i class="fas fa-plus-circle" @click="printOptionSettingUpdate(2,'colors', index, item.id, 'add');productsErrors[index].printOptions2 = ''" ></i>
                                <div style="display:inline-block;width:100px;" class="pr-2">Värien määrä</div>
                              </div>
                              <div v-if="item.extraCosts && item.extraCosts.length > 0" class="pt-2">
                                <div v-for="(ec, i) in item.extraCosts" :key="ec.id+'_ec_'+i">
                                  <i v-if="product.printOptionsSettings2[item.id] && product.printOptionsSettings2[item.id]['ec_'+ec.id]" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'ec_'+ec.id, index, item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                  <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'ec_'+ec.id, index, item.id, true)" class="far fa-square pl-1 pr-2"></i>
                                  <div style="display:inline-block;" class="pr-2">{{ec.name + ' ('+ec.price+'€)'}}</div>
                                </div>
                              </div>
                            </div>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-else cols="12" md="12" class="pr-3">
            <v-row no-gutters>
              <v-col cols="6" md="6" class="pr-3" v-if="products[product.productId] && products[product.productId].printFormats && Array.isArray(products[product.productId].printFormats) &&  products[product.productId].printFormats.length > 0">
                <v-autocomplete
                  label="Merkkaustapa*"
                  v-model="product.printFormats2"
                  :items="printFormatsForProduct(product)"
                  @change="e => productsErrors[index].printFormats2 = ''"
                  persistent-hint
                  item-text="fi"
                  item-value="id"
                  multiple
                  :error-messages="productsErrors[index].printFormats2"
                />
              </v-col>
              <v-col cols="6" md="6" class="pr-3" v-else>
                <v-text-field
                  label="Merkkaustapa"
                  @blur="fieldUpdated('printFormatsText2', index)"
                  @keyup="fieldUpdated('printFormatsText2', index)"
                  v-model="product.printFormatsText2"
                  v-if="product.secondPrint"
                  :error-messages="productsErrors[index].printFormatsText2"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6" class="pr-3" v-if="product.secondPrint">
                <v-autocomplete
                  :disabled="product.printFormats2.includes('laser') || product.printFormats2.includes('digital_print') || product.printFormats2.includes('uv_laser')"
                  :label="product.printFormats2.includes('laser') || product.printFormats2.includes('digital_print') || product.printFormats2.includes('uv_laser') ? '-' : 'Värien määrä*'"
                  v-model="product.numberOfPrintColors2"
                  :items="settings.numberOfPrintColors"
                  @change="e => productsErrors[index].numberOfPrintColors2 = ''"
                  persistent-hint
                  :error-messages="productsErrors[index].numberOfPrintColors2"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6" md="3" class="pr-3">
            <v-text-field
              v-if="product.secondPrint"  
              label="Merkkausväri"
              v-model="product.printColor2"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3" class="pr-3">
            <v-text-field
              v-if="product.secondPrint"  
              label="Merkkauskohta"
              v-model="product.printLocation2"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3" class="pr-3">
            <v-textarea
              v-if="product.secondPrint"  
              label="Mitä merkataan?"
              :auto-grow="true"
              v-model="product.printContent2"
              rows=1
              hint="Tuleeko lisäksi liitetietoja painettavaan tuotteeseen, esim. puh., www-osoite, tuotetietoja? Mitä?"
              persistent-hint
              class="small-hint"
            />
          </v-col>
          <v-col cols="12" md="3" class="pr-3">
            <v-textarea
              v-if="product.secondPrint"  
              label="Merkkauksen lisätiedot"
              :auto-grow="true"
              v-model="product.printComments2"
              rows=1
            />
          </v-col>
        </v-row>


        <v-row no-gutters  class="pt-5">
          <v-col cols="6" class="" v-if="products[product.productId] && products[product.productId].listed && products[product.productId].isMarginCalculationActivated && products[product.productId].pricingComments" style="font-size:10px;">
            <div style="font-weight:600;" class="pb-2">Hinnaston kommentit</div>
            <pre style="white-space:pre-wrap"><div style="display:inline-block;font-family:Roboto, sans-serif;">{{ products[product.productId].pricingComments }}</div></pre>
          </v-col>
          <v-col :cols="products[product.productId] && products[product.productId].listed && products[product.productId].isMarginCalculationActivated && products[product.productId].pricingComments ? 6 : 12" class="text-center pt-10" >
            Tuote yhteensä {{ calculateTotal(product) }}€
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="hidden-md-and-up  my-10">
      <v-col cols="12" class="text-center">
        <v-btn color="#000000" dark class="add-button avecor-button-global"  @click="addRow">Lisää tuote</v-btn>
      </v-col>
    </v-row>
    <!-- <v-snackbar v-model="settings.snack" :timeout="3000" :color="settings.snackColor">
      {{ settings.snackText }}
      <v-btn text @click="settings.snack = false">Close</v-btn>
    </v-snackbar> -->
  </div>
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import shared from './../../shared'

export default {
    created(){
      this.createVariationName = shared.createVariationName
      this.createVariationAvecorSku = shared.createVariationAvecorSku
      this.printFormatsFromPricingForProduct = shared.printFormatsFromPricingForProduct
      //this.calculateReserved = shared.calculateReserved
    },
    mounted() {
      const table = this.$refs.table
      //this.calculateReserved()
    },
    data: () => ({
      colors:1,
      table: null,
      isProductVariationSelectedWarehoused:false,
      editedIndex: -1,
      productDefaultItem: {
        sample:false,
        productId: '',
        productVariationId: '',
        customerProductName: '',
        productName: '',
        avecorSku:'',
        warehoused:false,
        quantity: '',
        color: '',
        size:'',
        numberOfSamples: 0,
        unitPrice: '',
        unitPrintPrice: '',
        printQuantity: '',
        printCostComments: '',
        packageType:'',
        numberOfPositionings: 1,
        pricePerPositioning: '',
        printOptions:[],
        printOptions2:[],
        printFormats:[],
        printFormats2:[],
        newPrintOptionsInUse:false,
        printOptionsSettings:{},
        printOptionsSettings2:{},
        //printOptionsRenewal:{},
        //printOptionsColors:{},
        printFormatsText:'',
        numberOfPrintColors:null,
        numberOfPrintColors2:null,
        print: false,
        secondPrint:false,
        printColor: "",
        printLocation: "",
        printContent:"",
        printComments: "",
        printColor2: "",
        printLocation2: "",
        printContent2:"",
        printComments2: "",
        latestToCustomer: '',
        whenToInvoice:'',
      },
      productErrorDefaultItem: {
          sample:'',
          productId: '',
          productVariationId: '',
          customerProductName: '',
          productName: '',
          avecorSku:'',
          warehoused:'',
          color:'',
          size:'',
          packageType:'',
          quantity: '',
          numberOfSamples: '',
          unitPrice: '',
          unitPrintPrice: '',
          printQuantity: '',
          printCostComments:'',
          numberOfPositionings: '',
          pricePerPositioning:'',
          printFormats:'',
          printFormats2:'',
          printOptions:'',
          printOptions2:'',
          //printOptionsRenewal:'',
          //printOptionsColors:'',
          printFormatsText:'',
          printFormatsText2:'',
          numberOfPrintColors:'',
          numberOfPrintColors2:'',
      },
      productsOtherInfoDefaultItem: {
          existingProductSelected:false
      },
      
        
      date: new Date().toISOString().substr(0, 10),
    }),
    computed: {
      isSamplesOrder(){
        if (this.typeOfOrder === 'sample') return true
        else return false
      },
      getTotal: {
        get: function () {
          return (
            Number(this.newOrderProducts.reduce((acc, currValue, currIndex, array) => { 
              return acc + (currValue.unitPrice * currValue.quantity) 
            },0))
            + Number(this.newOrderProducts.reduce((acc, currValue, currIndex, array) => { 
              return acc + (currValue.unitPrintPrice * currValue.printQuantity) 
            },0)) 
            + Number(this.newOrderProducts.reduce((acc, currValue, currIndex, array) => { 
              return acc + (currValue.pricePerPositioning * currValue.numberOfPositionings) 
            },0))
              + Number(this.deliveryCharges)
            ).toFixed(2)
        },
        // setter
        set: function (newValue) {
          
        }
      },
      areTherePrintProducts(){
        var numberOfPrintProducts = Number(this.newOrderProducts.reduce((acc, currValue, currIndex, array) => { 
            return acc + currValue.print ? 1 : 0
          },0))
        if (numberOfPrintProducts > 0) return true
        return false
      },
      getGenders(){
        var genders = this.settings.genders
        return Object.keys(this.settings.genders).reduce(function(result, key) {
          result.push({...genders[key]});
          return result;
        }, []);
      },
      getPackageTypes(){
        var packageTypes = this.settings.packageTypes
        return Object.keys(this.settings.packageTypes).reduce(function(result, key) {
          result.push({...packageTypes[key]});
          return result;
        }, []);
      },
      
      formTitle () {
        return this.editedIndex === -1 ? 'Lisää tuote' : 'Muokkaa tuotetta'
        
      },
      getCatalogProducts(){
        var products = this.products
        var catalogProducts = []
        Object.keys(this.products).map(function(key, index) {
          var p = products[key]
          if(!p.archived) catalogProducts.push({text: p.name.fi, value: p.id})
          return ""
        })
        return catalogProducts
      },
      getCatalogProductsAndVariations(){
        var products = this.products
        var productVariations = this.productVariations
        var catalogProducts = []
        Object.keys(productVariations).forEach(key => {
          var pv = productVariations[key]
          if(products[pv.productId] !== undefined) {
            if (products[pv.productId].archived === undefined || products[pv.productId].archived == false){
              if (pv.archived === undefined || pv.archived == false){
                var sku = this.createVariationAvecorSku(pv.id)
                catalogProducts.push({text: products[pv.productId].name.fi + " - " + this.createVariationName(pv) + ' - ' + sku, value: pv.id})
              }
            }
          }
        })
        return catalogProducts
      },
      
      ...mapFields({
        user:'user',
        reserved:'reserved',
        products:'product.products',
        productVariations:'productVariation.productVariations',
        orderedProducts:'orderedProduct.orderedProducts',
        printShops:'printShop.printShops',
        settings:"settings",
        //isSamplesOrder:'newOrderDetails.isSamplesOrder',
        typeOfOrder:'newOrderDetails.typeOfOrder',
        samplesArray:"newOrderDetails.samplesArray",
        deliveryCharges:"newOrderDetails.deliveryCharges",
        deliveryBySalesperson:"newOrderDetails.deliveryBySalesperson",
        isAmendmentOrder:"newOrderDetails.isAmendmentOrder",
        positioningCharges:"newOrderDetails.positioningCharges",
        clientEmail:"newOrderDetails.clientEmail",
        orderedProductInvoiceStyles:"settings.orderedProductInvoiceStyles"
      }),
      ...mapMultiRowFields({
        newOrderProducts: "newOrderDetails.products2",
        productsErrors: "newOrderDetails.productsErrors",
        productsOtherInfo: "newOrderDetails.productsOtherInfo"
      })
    },
    methods: {
      addOrRemovePrintOption(i,action,poId){
        var product = this.newOrderProducts[i]
        
        if(action === 'add'){
          var printOptionsSettings = JSON.parse(JSON.stringify(product.printOptionsSettings))
          if(!printOptionsSettings[poId]){
            this.newOrderProducts[i].printOptionsSettings[poId] = {}
          }
          var printOptions = JSON.parse(JSON.stringify(product.printOptions))
          if(!printOptions.includes(poId)){
            this.newOrderProducts[i].printOptions.push(poId)
          }
        }
        else if(action === 'remove'){
          console.log("REMOVING")
          var printOptionsSettings = JSON.parse(JSON.stringify(product.printOptionsSettings))
          if(printOptionsSettings[poId]){
            delete printOptionsSettings[poId]
            this.newOrderProducts[i].printOptionsSettings = printOptionsSettings
          }
          var printOptions = JSON.parse(JSON.stringify(product.printOptions))
          if(printOptions.includes(poId)){
            this.newOrderProducts[i].printOptions = printOptions.filter(id => id !== poId )
          }
          console.log({printOptions,printOptionsSettings})
        }
      },
      addOrRemovePrintOption2(i,action,poId){
        var product = this.newOrderProducts[i]
        
        if(action === 'add'){
          var printOptionsSettings2 = JSON.parse(JSON.stringify(product.printOptionsSettings2))
          if(!printOptionsSettings2[poId]){
            this.newOrderProducts[i].printOptionsSettings2[poId] = {}
          }
          var printOptions2 = JSON.parse(JSON.stringify(product.printOptions2))
          if(!printOptions2.includes(poId)){
            this.newOrderProducts[i].printOptions2.push(poId)
          }
        }
        else if(action === 'remove'){
          console.log("REMOVING")
          var printOptionsSettings2 = JSON.parse(JSON.stringify(product.printOptionsSettings2))
          if(printOptionsSettings2[poId]){
            delete printOptionsSettings2[poId]
            this.newOrderProducts[i].printOptionsSettings2 = printOptionsSettings2
          }
          var printOptions2 = JSON.parse(JSON.stringify(product.printOptions2))
          if(printOptions2.includes(poId)){
            this.newOrderProducts[i].printOptions2 = printOptions2.filter(id => id !== poId )
          }
          console.log({printOptions2,printOptionsSettings2})
        }
      },
      printOptionSettingUpdate(printNumber,setting, i, poId, value){
        var product = this.newOrderProducts[i]
        var printOptionsSettings = null
        if(printNumber === 1) printOptionsSettings = JSON.parse(JSON.stringify(product.printOptionsSettings))
        if(printNumber === 2) printOptionsSettings = JSON.parse(JSON.stringify(product.printOptionsSettings2))
        if(setting === 'renewal'){
          if(value === false) {
            if(printOptionsSettings[poId] && printOptionsSettings[poId].renewal) delete printOptionsSettings[poId].renewal
          }
          else {
            if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
            printOptionsSettings[poId].renewal = true
          }
        }
        else if(setting === 'colors'){
          if(value === 'add'){
            if(printOptionsSettings[poId] !== undefined && printOptionsSettings[poId].colors !== undefined) printOptionsSettings[poId].colors += 1
            else {
              if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
              printOptionsSettings[poId].colors = 1
            }
          }
          else if (value === 'subtract'){
            if(printOptionsSettings[poId] !== undefined && printOptionsSettings[poId].colors !== undefined) printOptionsSettings[poId].colors -= 1
            else {
              if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
              printOptionsSettings[poId].colors = 1
            }
          }
          else if (value === 'remove'){
            if(printOptionsSettings[poId] !== undefined && printOptionsSettings[poId].colors !== undefined) delete printOptionsSettings[poId].colors
          }
          else if (!isNaN(Number(value))){
            if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
            printOptionsSettings[poId].colors = value
          }
        }
        else if(setting.includes('ec_')){
          if(value === false) {
            if(printOptionsSettings[poId] && printOptionsSettings[poId][setting]) delete printOptionsSettings[poId][setting]
          }
          else {
            if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
            printOptionsSettings[poId][setting] = 1
          }
        }
        if(printNumber === 1) this.newOrderProducts[i].printOptionsSettings = printOptionsSettings
        if(printNumber === 2) this.newOrderProducts[i].printOptionsSettings2 = printOptionsSettings
        //this.newOrderProducts[i].printOptionsSettings = printOptionsSettings
      
      },
      updateColors(v){
        console.log(v)
        //this.colors = v
      },
      printFormatsForProduct(product){
        var formats = []
        if(this.products[product.productId] && this.products[product.productId].printFormats && Array.isArray(this.products[product.productId].printFormats)){
          this.products[product.productId].printFormats.forEach(format => {
            if(this.settings.printFormatsObject[format]) formats.push(this.settings.printFormatsObject[format])
          })
        }
        return formats
      },
      getFreeStock(pvId){
        try{
          var pv = this.productVariations[pvId]
          return this.productVariations[pvId].avecorStock - this.reserved['avecor'][pv.productId].variations[pvId].total
        }
        catch(e){console.log(e); return 0}
      },
      getTotalStock(pvId){
        var aStock = !isNaN(Number(this.productVariations[pvId].avecorStock)) ? this.productVariations[pvId].avecorStock : 0
        var pStock = !isNaN(Number(this.productVariations[pvId].printShopStock)) ? this.productVariations[pvId].printShopStock : 0
        return aStock + pStock
      },
      toggledProductPrint(){
        
      },
      removeProductSelection (index) {
        this.productsOtherInfo[index].existingProductSelected = false
        this.newOrderProducts[index].productVariationId = ""
        this.newOrderProducts[index].productId = ""
        this.newOrderProducts[index].productName = ""
        this.newOrderProducts[index].warehoused = false
        this.newOrderProducts[index].avecorSku = ""
        this.newOrderProducts[index].color = ""
        this.newOrderProducts[index].size = ""
        this.newOrderProducts[index].printFormats = []
        this.newOrderProducts[index].printOptions = []
        this.newOrderProducts[index].printFormatsText = ''
        
        this.newOrderProducts[index].packageType = ""
        this.productsErrors[index].productVariationId = ""
        this.productsErrors[index].productId = ""
        this.productsErrors[index].productName = ""
        this.productsErrors[index].packageType = ""
        this.productsErrors[index].printFormats = ""
        this.productsErrors[index].printOptions = ""
        this.productsErrors[index].printFormatsText = ""
        this.productsErrors[index].numberOfPrintColors = ""
      },
      productFieldChanged(index) {
        if (this.newOrderProducts[index].productVariationId) {
          console.log("HERE")
          console.log(this.newOrderProducts[index].productVariationId)
          var variationId = this.newOrderProducts[index].productVariationId
          var pv = this.productVariations[variationId] ? this.productVariations[variationId] : ''
          this.newOrderProducts[index].warehoused = pv.warehoused !== undefined ? pv.warehoused : false
          var p = this.products[pv.productId]
          this.productsOtherInfo[index].existingProductSelected = true
          this.newOrderProducts[index].productId = p.id
          this.newOrderProducts[index].productName = p.name.fi
          this.newOrderProducts[index].packageType = pv.packageType
          this.newOrderProducts[index].printFormats = []
          this.newOrderProducts[index].printFormats2 = []
          this.newOrderProducts[index].printOptions = []
          this.newOrderProducts[index].printOptions2 = []
          this.newOrderProducts[index].printOptionsSettings = {}
          this.newOrderProducts[index].printOptionsSettings2 = {}
          //this.newOrderProducts[index].printOptionsRenewal = {}
          //this.newOrderProducts[index].printOptionsColors = {}
          this.newOrderProducts[index].printFormatsText = ''
          this.newOrderProducts[index].printFormatsText2 = ''
          var colorName = ""
          var colorCode = ""
          pv.colorCode && this.settings.colors[pv.colorCode] ? colorName = this.settings.colors[pv.colorCode].fi : ''
          pv.colorCode && this.settings.colors[pv.colorCode] ? colorCode = this.settings.colors[pv.colorCode].id : ''
          this.newOrderProducts[index].color = colorName
          this.newOrderProducts[index].avecorSku = p.avecorSku ? p.avecorSku : ''
          this.newOrderProducts[index].avecorSku += colorCode ? '-'+colorCode : ''
          this.newOrderProducts[index].size = pv.size ? pv.size : ""
          this.productsErrors[index].productId = ""
          this.productsErrors[index].productVariationId = ""
          this.productsErrors[index].productName = ""
          this.productsErrors[index].packageType = ""
          this.productsErrors[index].printFormats = ""
          this.productsErrors[index].printFormats2 = ""
          this.productsErrors[index].printOtions = ""
          this.productsErrors[index].printOtions2 = ""
          this.productsErrors[index].printFormatsText = ""
          this.productsErrors[index].printFormatsText2 = ""
          
          this.productsErrors[index].numberOfPrintColors = ""
          this.productsErrors[index].numberOfPrintColors2 = ""
          
          if(p.listed && p.isMarginCalculationActivated) this.newOrderProducts[index].newPrintOptionsInUse = true
          else {this.newOrderProducts[index].newPrintOptionsInUse = false}
        }
        else {
          this.productsOtherInfo[index].existingProductSelected = false
        }
      },
      fieldUpdated(field, i){
        field === "productId" && this.newOrderProducts[i].productId.trim() === "" ? this.productsErrors[i].productId = "Täytä" : null
        field === "productId" && this.newOrderProducts[i].productId.trim() !== "" ? this.productsErrors[i].productId = "" : null
        field === "productVariationId" && this.newOrderProducts[i].productVariationId.trim() === "" ? this.productsErrors[i].productVariationId = "Täytä" : null
        field === "productVariationId" && this.newOrderProducts[i].productVariationId.trim() !== "" ? this.productsErrors[i].productVariationId = "" : null
        field === "productName" && this.newOrderProducts[i].productName.trim() === "" ? this.productsErrors[i].productName = "Täytä" : null
        field === "productName" && this.newOrderProducts[i].productName.trim() !== "" ? this.productsErrors[i].productName = "" : null
        field === "packageType" && this.newOrderProducts[i].packageType.trim() === "" ? this.productsErrors[i].packageType = "Täytä" : null
        field === "packageType" && this.newOrderProducts[i].packageType.trim() !== "" ? this.productsErrors[i].packageType = "" : null
        console.log(field, i)
        field === "printFormatsText" && this.newOrderProducts[i].printFormatsText.trim() !== "" ? this.productsErrors[i].printFormatsText = "" : null
        //field === "customerProductName" && this.newOrderProducts[i].customerProductName.trim() === "" ? this.productsErrors[i].customerProductName = "Täytä" : null
        //field === "customerProductName" && this.newOrderProducts[i].customerProductName.trim() !== "" ? this.productsErrors[i].customerProductName = "" : null
        field === "quantity" && this.newOrderProducts[i].quantity.trim() === "" ? this.productsErrors[i].quantity = "Täytä" : null
        field === "quantity" && this.newOrderProducts[i].quantity.trim() !== "" ? this.productsErrors[i].quantity = "" : null
        if(this.newOrderProducts[i].print){
          field === "printQuantity" && this.newOrderProducts[i].printQuantity.trim() === "" ? this.productsErrors[i].printQuantity = "Täytä" : null
          field === "printQuantity" && this.newOrderProducts[i].printQuantity.trim() !== "" ? this.productsErrors[i].printQuantity = "" : null
        }
        if (field === "unitPrice" && this.newOrderProducts[i].unitPrice.trim() === "") this.productsErrors[i].unitPrice = "Täytä"
        else if (field === "unitPrice" && this.newOrderProducts[i].unitPrice.trim() !== "" && this.newOrderProducts[i].unitPrice.includes(',')) {
          this.newOrderProducts[i].unitPrice = this.newOrderProducts[i].unitPrice.replace(",", ".")
          this.productsErrors[i].unitPrice = ""
        }
        else this.productsErrors[i].unitPrice = ""
        if (field === "unitPrintPrice" && this.newOrderProducts[i].unitPrintPrice.trim() === "") this.productsErrors[i].unitPrintPrice = "Täytä"
        else if (field === "unitPrintPrice" && this.newOrderProducts[i].unitPrintPrice.trim() !== "" && this.newOrderProducts[i].unitPrintPrice.includes(',')) {
          this.newOrderProducts[i].unitPrintPrice = this.newOrderProducts[i].unitPrintPrice.replace(",", ".")
          this.productsErrors[i].unitPrice = ""
        }
        else this.productsErrors[i].unitPrintPrice = ""
        if (field === "pricePerPositioning") this.newOrderProducts[i].pricePerPositioning = this.newOrderProducts[i].pricePerPositioning.replace(",", ".")
        
      },
      calculateTotal(item) {

        return Number((item.unitPrice * item.quantity)
          + (item.unitPrintPrice * item.printQuantity) 
          + (item.pricePerPositioning * item.numberOfPositionings))
        .toFixed(2)
      },
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      addRow(){
        this.$store.dispatch('newRow', {
          product:{...this.productDefaultItem}, 
          productError:{...this.productErrorDefaultItem},
          productOtherInfo:{...this.productsOtherInfoDefaultItem}
        })
      },
      deleteItem (index) {
        //const index = this.newOrderProducts.indexOf(item)
        this.$store.dispatch('deleteRow', index)
      },
      
      inlineSave (item) {
        var index = this.newOrderProducts.indexOf(item) 
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      positioningChargesSave (newCharge) {
        this.positioningCharges = newCharge
        this.settings.snack = true
        this.settings.snackColor = 'success'
        this.settings.snackText = 'Päivitetty'
      },
      deliveryChargesSave (newCharge) {
        this.deliveryCharges = newCharge
        this.settings.snack = true
        this.settings.snackColor = 'success'
        this.settings.snackText = 'Päivitetty'
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/NewOrderNormalGrid.vue